module.exports = __webpack_public_path__ + "img/avatar3.2509c89c.png";